module.exports = __webpack_public_path__ + "img/drag_drop.28515119.png";